/**
 * ChatMessages - Renders list of messages
 */

import { useAuth } from '../../contexts/AuthContext'
import ChatMessage from './ChatMessage'
import ChatEmptyState from './ChatEmptyState'
import { getFirstNameOnly } from '../../lib/privacy/sanitizeTalentData'

interface Message {
  id: string
  sender_id: string
  message_text: string
  attachment_url?: string
  attachment_type?: string
  attachment_name?: string
  created_at: string
  sender: {
    id: string
    full_name: string
    avatar_url?: string
  }
}

interface ChatMessagesProps {
  messages: Message[]
  currentChat: any
}

export default function ChatMessages({ messages, currentChat }: ChatMessagesProps) {
  const { user, profile } = useAuth()

  // Determine the other person's name for the empty state
  const isPhotographer = profile?.role === 'photographer'
  const talentNames = [
    currentChat?.photographer?.full_name,
    currentChat?.videographer?.full_name,
    currentChat?.secondPhotographer?.full_name
  ].filter(Boolean).map((name) => getFirstNameOnly(name))
  const otherPersonName = isPhotographer
    ? (currentChat?.customer?.full_name ? getFirstNameOnly(currentChat.customer.full_name) : 'your client')
    : (talentNames.length > 0 ? talentNames.join(' + ') : 'your wedding team')

  if (messages.length === 0) {
    return <ChatEmptyState photographerName={otherPersonName} />
  }

  return (
    <div className="space-y-4">
      {messages.map((message) => {
        const isOwnMessage = message.sender_id === user?.id

        return (
          <ChatMessage
            key={message.id}
            message={message}
            isOwnMessage={isOwnMessage}
          />
        )
      })}
    </div>
  )
}
